import { useCallback, useState } from "react";
import axiosInstance from "../utilities/request-utility";

export function useMutation(
  initialUrl,
  options
) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(
    async (
      payload,
      path,
      queryParams
    ) => {
      setIsLoading(true);
      setIsError(false);
      setIsSuccess(false);
      setError(null);
      setData(null);

      let finalUrl = initialUrl;
      if (path) {
        finalUrl += `/${path}`;
      }

      if (queryParams) {
        const query = new URLSearchParams(queryParams).toString();
        finalUrl += `?${query}`;
      }

      try {
        const axios = axiosInstance(); // call your axiosInstance factory
        const response = await axios.request({
          url: finalUrl,
          method: options.method,
          data: payload,
        });

        setData(response.data);
        setIsSuccess(true);
      } catch (err) {
        setError(err);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    },
    [initialUrl, options]
  );

  const reset = useCallback(() => {
    setData(null);
    setIsLoading(false);
    setIsError(false);
    setIsSuccess(false);
    setError(null);
  }, []);

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    error,
    mutate,
    reset,
  };
}